__turbopack_context__.v({
  "container": "CheckoutComDropInCheckout-module__Q1LFpq__container",
  "creditCardNote": "CheckoutComDropInCheckout-module__Q1LFpq__creditCardNote",
  "flowContainer": "CheckoutComDropInCheckout-module__Q1LFpq__flowContainer",
  "outsideUkContainer": "CheckoutComDropInCheckout-module__Q1LFpq__outsideUkContainer",
});
